var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-group",
    class: {
      'button-group--centered': _vm.isCentered
    }
  }, [_vm.backButtonIsVisible ? _c('button', {
    staticClass: "btn btn-secondary",
    class: {
      'btn--left': _vm.isCentered
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('back');
      }
    }
  }, [_vm._v(" 返回 ")]) : _vm._e(), _vm.nextButtonIsVisible ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      'btn--right': !_vm.isCentered
    },
    style: !_vm.canProceed ? {
      opacity: '0.6',
      cursor: 'not-allowed'
    } : {},
    attrs: {
      "disabled": !_vm.canProceed
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('next');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.textForNextStep) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }